import React from "react";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { fetchUserDetails,fetchState,fetchCompanyTypes , fetchJobRoles , createUser } from "../../api/user"
import { useState } from "react";


const EditAccountForm = ({changeLoaderStatus}) => {

  
    const [userfetched,setuserFetched] = useState(false)
    const [userdata,setUserData] = useState(null)
    const [userdetails,setUserDetails] = useState(null)
    const [otherCountry , setOtherCountry] = useState(false)
    const [otherCountryName , setOtherCountryName] = useState("")
    const [states , setStates ] = useState([])
    const [companyTypes , setCompanyTypes ] = useState(null)
    const [jobRoles , setJobRoles ] = useState(null)
    const [companyTypeDealer,setcompanyTypeDealer] = useState(false)
    const [uto_promo_code1 , setuto_promo_code1 ] = useState("")
    const [uto_promo_code2 , setuto_promo_code2] = useState("")
    const [uto_promo_code3 , setuto_promo_code3 ] = useState("")
    const [first_name , setfirst_name ] = useState("")
    const [last_name , setlast_name ] = useState("")
    const [title , settitle ] = useState("")
    const [company , setcompany ] = useState("")
    const [city , setcity ] = useState("")
    const [country , setcountry ] = useState("")
    const [state , setstate ] = useState("")
    const [zip , setzip ] = useState("")
    const [product_used , setproduct_used ] = useState("")
    const [fypon_used , setfypon_used] = useState("")
    const [company_type_id , setcompany_type_id] = useState("")
    const [job_role_id , setjob_role_id] = useState("")
    const [distributor , setdistributor] = useState("")
    const [distributor_location , setdistributor_location] = useState("")
    const [sales_representative , setsales_representative] = useState("")
    const [usemail , setUserMail] = useState("")

    const { register, handleSubmit,setValue, formState: { errors } } = useForm({ mode: 'onChange' });

    useEffect(() => {
        if (userdetails) {


            setValue('uto_promo_code1',uto_promo_code1, { shouldValidate: true })
            setValue('uto_promo_code2',uto_promo_code2, { shouldValidate: true })
            setValue('uto_promo_code3',uto_promo_code3, { shouldValidate: true })
            setValue('first_name',first_name, { shouldValidate: true })
            setValue('last_name',last_name, { shouldValidate: true })
            setValue('title',title, { shouldValidate: true })
            setValue('company',company, { shouldValidate: true })
            setValue('city',city, { shouldValidate: true })
            setValue('country',country, { shouldValidate: true })
            setValue('state',state, { shouldValidate: true })
            setValue('zip',zip, { shouldValidate: true })
            setValue('product_used',product_used, { shouldValidate: true })
            setValue('fypon_used',fypon_used, { shouldValidate: true })
            setValue('company_type_id',company_type_id, { shouldValidate: true })
            setValue('job_role_id',job_role_id, { shouldValidate: true })
            setValue('distributor',distributor, { shouldValidate: true })
            setValue('distributor_location',distributor_location, { shouldValidate: true })
            setValue('sales_representative',sales_representative, { shouldValidate: true })

            
        }
    }, [userdetails]);

    const fetchUserData = () => {


        let user_id = sessionStorage.getItem("user_id");
        if(user_id) {
            let user = fetchUserDetails(user_id);
            let that = this
            user.then(function (val)  {

                if(val.data.user) {

                    setUserData(val.data.user)
                    setUserDetails(val.data.user.details)
                    setuserFetched(true)
        
                    if(val.data.user.details){
    
                        setuto_promo_code1(val.data.user.details.uto_promo_code1)
                        setuto_promo_code2(val.data.user.details.uto_promo_code2)
                        setuto_promo_code3(val.data.user.details.uto_promo_code3)
                        
                        setUserMail(val.data.user.email)
                        setfirst_name( val.data.user.first_name)
                        setlast_name( val.data.user.last_name)
                        settitle( val.data.user.details.title)
                        setcompany( val.data.user.details.company)
                        setcity( val.data.user.details.city)


                        if(val.data.user.details.country === "USA"){
                            setcountry(  val.data.user.details.country)
                        }
                        else if(val.data.user.details.country === "Canada"){
                            setcountry(  val.data.user.details.country)
                        }
                        else{
                            setOtherCountryName(val.data.user.details.country)
                            setcountry("Other")
                        }

                        
                        setstate(  val.data.user.details.state)
                        setzip(  val.data.user.details.zip)
                        setproduct_used(  val.data.user.details.product_used)
                        setfypon_used(  val.data.user.details.fypon_used)
                        setcompany_type_id(  val.data.user.details.company_type_id)
                        setjob_role_id(  val.data.user.details.job_role_id)
                        setdistributor(  val.data.user.details.distributor)
                        setdistributor_location(  val.data.user.details.distributor_location)
                        setsales_representative(  val.data.user.details.sales_representative)
    
                  
                    }
    
                    if( val.data.user.details.job_role_id === 4) {
    
                        setcompanyTypeDealer(true)
    
                    }
    
                    if( val.data.user.details.country === "USA" || val.data.user.details.country === "Canada" ) {
    
                        let states = fetchState(val.data.user.details.country);
    
    
                        states.then((value) => {
    
                
                            if(value.data.response === "success") {
    
                                setStates(value.data.states)
                                setOtherCountry(false)
    
                            }
    
    
                        })
                        .catch((error) => {
    
                        })
    
                    }else{

                        setOtherCountry(true)

                    }

                    changeLoaderStatus(false)

                }else{

                    changeLoaderStatus(false)

                }

           

            })


                    
            let companytypes = fetchCompanyTypes();
            let jobroles = fetchJobRoles();

            companytypes.then((value) => {

                if(value.data.response === "success") {

                    let com_types = sortjsonArrayById(value.data.company_types)
                    setCompanyTypes(com_types)
                }
            })
            .catch((error) => {

            })


            jobroles.then((value) => {
                if(value.data.response === "success") {
                    let job_roles = sortjsonArrayById(value.data.job_roles)
                    setJobRoles(job_roles)
                }
            })
            .catch((error) => {

            })
        }
    }

    useEffect(
        () => {
            changeLoaderStatus(true)

            fetchUserData();
        },[]
    )


    const sortjsonArrayById = (arr) => {

        arr.sort(function(a,b){
            return a.id - b.id;
            }
        );

        return arr;
    }

    const handleCompany =(e) => {
        let val = e.target.value;

        if(val === "4") {

            setcompanyTypeDealer(true)
        }
        else{
            setcompanyTypeDealer(false)


        }
    }


    const handleCountry = (e) => {
        let val = e.target.value;
        if(val  === "Other") {

            setOtherCountry(true)
        }
        else{

            let states = fetchState(val);

            states.then((value) => {

    
                if(value.data.response === "success") {

                    setStates(value.data.states)
                    setOtherCountry(false)

                }


            })
            .catch((error) => {

               
            })

        }


    }

    const onSubmit = (data) => {


        // console.log(data);
        // return;
        let user_id = sessionStorage.getItem("user_id");

        if(user_id){

            data.id = user_id;
            data.user_id = user_id;
            data.email = usemail;
            if(data.country === "Other"){

                data.country = data.other_country
            }
            changeLoaderStatus(true)

            let user = createUser(data);
            user.then((value) => {
    
                if(value.data.response === "success") {
    
                    alert("Profile updated")
                    fetchUserData();
                }

                if(value.data.response === "error") {

                    alert(value.data.message)
                    changeLoaderStatus(false)


                }
            })

        }
        
    }


    // $('#editAccountForm').on('hide.bs.modal', function (e) {
    //     $("#profile_wrapper").removeClass("d-none")
    //     $(".navigation-container").show();
    //     $(".nav-header-div").show();
    // });


    return(
    
        <div className="popup_div_favorite edit_account_form p-5">
            <div className="text-center">
                <img className="img-fluid" src="images/pop_logo_2.png" alt="" />
            </div>
            <div className="update_profile_div">
                <form  onSubmit={handleSubmit(onSubmit)}>
                <h3>Update Profile</h3>
                <div className="promo_code_pop_inner update_profile_inner mt-4 custom_scroll">
                <h4>Promo Codes</h4>
                <div className="row">

                    <div className="col-sm-12 mb-3">
                        <label>Keys 2 Success Promo Code 1 (Optional)</label>
                        <input type="text" placeholder="Keys 2 Success Promo Code 1 (Optional)" className="form-control" 
                        name="uto_promo_code1"
                         {...register("uto_promo_code1")}
                        onChange={(e) =>  {   setuto_promo_code1( e.target.value)   } }/>
                    </div>

                    <div className="col-sm-12 mb-3">
                        <label>Keys 2 Success Promo Code 2 (Optional)</label>
                        <input type="text" placeholder="Keys 2 Success Promo Code 2 (Optional)" className="form-control" 
                        onChange={(e) =>  {   setuto_promo_code2( e.target.value)   } }
                        name="uto_promo_code2"
                        {...register("uto_promo_code2")}
                       />
                    </div>

                    <div className="col-sm-12 mb-3">
                        <label>Keys 2 Success Promo Code 3 (Optional)</label>
                        <input type="text" placeholder="Keys 2 Success Promo Code 3 (Optional)" className="form-control" 
                        onChange={(e) =>  {   setuto_promo_code3( e.target.value)   } }
                        name="uto_promo_code3"
                        {...register("uto_promo_code3")}
                        />
                    </div>

                    <div className="col-sm-6 mb-3">
                        <label>First Name</label>
                        <input type="text" name="first_name" placeholder="First Name"  {...register("first_name",{ required : true})}
                        className="form-control"  onChange={(e) =>  {   setfirst_name( e.target.value)   }
                        }/> 
                        {errors.first_name && <span className="is-danger">The first name field is required</span>}
                    </div>


                    <div className="col-sm-6 mb-3">
                        <label>Last Name</label>
                        <input type="text" name="last_name" placeholder="Last Name" data-vv-as="last name"  {...register("last_name",{ required : true})}
                            className="form-control" aria-required="true" aria-invalid="false"
                            onChange={(e) =>  {   setlast_name( e.target.value)   } }

                            />
                        {errors.last_name && <span className="is-danger">The last name field is required</span>}
                    </div>

                    <div className="col-sm-6 mb-3">
                        <label>Title</label>
                        <input type="text" name="title" placeholder="Title"  className="form-control" aria-required="true"
                             {...register("title",{ required : true})}
                            onChange={(e) =>  {   settitle( e.target.value)   } }

                        aria-invalid="false" /> 
                        {errors.title && <span className="is-danger">The title field is required</span>}

                    </div>

                    <div className="col-sm-6 mb-3">
                        <label>Company</label>
                        <input type="text" placeholder="Company" name="company"  className="form-control" aria-required="true"
                              {...register("company",{ required : true})}
                             onChange={(e) =>  {   setcompany( e.target.value)   } }

                                aria-invalid="false" /> 
                          {errors.company && <span className="is-danger">The company field is required</span>}

                    </div>


                    <div className="col-sm-6 mb-3">
                        <label>City</label>
                        <input type="text" placeholder="City" name="city" className="form-control" aria-required="true"
                       {...register("city",{ required : true})}
                        onChange={(e) =>  {   setcity( e.target.value)   } }

                        aria-invalid="false" /> 
                        {errors.city && <span className="is-danger">The city field is required</span>}
                    </div>


                    <div className="col-sm-6 mb-3">
                        <label>Country</label>
                        <select name="country" id="Country"  className="form-control" aria-required="true"
                            {...register("country",{ required : true})}
                            aria-invalid="false"  onChange={(e) =>  {   setcountry( e.target.value); handleCountry(e)  } }>
                            <option value="USA">USA</option>
                            <option value="Canada" >Canada</option>
                            <option value="Other"> Other</option>
                        </select> 
                        {errors.country && <span className="is-danger">The country field is required</span>}
                    </div>


                    {
                        !otherCountry && (

                            <div className="col-sm-6 mb-3">
                                <label>State</label>

                                <select className="form-control form-control-lg" name="state"  {...register("state",{ required : true})}
                                onChange={(e) =>  {   setstate( e.target.value);} }

                                >

                                    {
                                        states && states.map(val => {

                                            return <option key={val} value={val} >{val}</option>
                                        })
                                    }
                                </select>
                                {errors.state && <span className="is-danger">The state field is required</span>}

                                
                            </div>
                        )
                    }
                   
                   {

                        otherCountry && (
                            <>
                                <div className="col-sm-6 mb-3">
                                    <label>Country</label>

                                    <input type="text" className="form-control form-control-lg" name="other_country" placeholder="Country" 
                                    {...register("other_country",{ required : true})}
                                    onChange={(e) =>  {   setOtherCountryName( e.target.value);} }

                                    />
                                     {errors.other_country && <span className="is-danger">The country field is required</span>}

                                </div>

                                <div className="col-sm-6 mb-3">
                                    <label>State</label>

                                    <input type="text" className="form-control form-control-lg"  name="state" placeholder="State" {...register("state",{ required : true})}
                                    onChange={(e) =>  {   setstate( e.target.value);} }
                                         />
                                     {errors.state && <span className="is-danger">The state field is required</span>}
                                </div>
                            </>
                            
                        )
                    }

                    <div className="col-sm-6 mb-3">
                        <label>ZIP Code</label>
                        <input type="text" placeholder="ZIP Code" name="zip" className="form-control" aria-required="true"
                        
                                                            onChange={(e) =>  {   setzip( e.target.value);} }

                           {...register("zip",{ required : true})} aria-invalid="false" />
                        {errors.zip && <span className="is-danger">The zip field is required</span>}
                    </div>
                    
                    <div className="col-sm-6 mb-3">
                        <label>USED THERMA-TRU PRODUCTS IN PAST 12 MONTHS?</label>

                        <select name="product_used"  className="form-control" aria-required="true" 
                              onChange={(e) =>  {   setproduct_used( e.target.value);} }

                                aria-invalid="false" {...register("product_used",{ required : true})}>
                                <option value="">USED THERMA-TRU PRODUCTS IN PAST 12 MONTHS?</option>
                                <option value="yes" >YES</option>
                                <option value="no" >NO</option>
                        </select> 
                        {errors.product_used && <span className="is-danger">*Required</span>}

                    </div>

                    <div className="col-sm-6 mb-3">

                        <label>USED FYPON PRODUCTS IN PAST 12 MONTHS?</label>
                        <select name="fypon_used"  className="form-control" aria-required="true" aria-invalid="false"
                          onChange={(e) =>  {   setfypon_used( e.target.value);} }

                        {...register("fypon_used",{ required : true})}>
                                <option value="">USED FYPON PRODUCTS IN PAST 12 MONTHS?</option>
                                <option value="yes" >YES</option>
                                <option value="no">NO</option>
                        </select> 
                        {errors.fypon_used && <span className="is-danger">*Required</span>}

                    </div>
                    
                    <div className="col-sm-6 mb-3">
                        <label>Company Type</label>
                        <select className="form-control form-control-lg" id="exampleFormControlSelect1"  {...register("company_type_id",{ required : true})}
                                                  onChange={(e) =>  { handleCompany(e);  setcompany_type_id( e.target.value);} }
                                                name="company_type_id"
                        >
                                {
                                    companyTypes && companyTypes.map(val => {

                                        return <option key={val.id} value={val.id} >{val.type}</option>
                                    })
                                }
                        </select>
                        {errors.company_type_id && <span className="is-danger">*Required</span>}
                    </div>


                    <div className="col-sm-6 mb-3">
                        <label>Job Role</label>
                            <select className="form-control form-control-lg" {...register("job_role_id",{ required : true})}
                                onChange={(e) =>  {   setjob_role_id( e.target.value);} }
                                name="job_role_id"


                            >
                            {
                                jobRoles && jobRoles.map(val => {
                                    return <option key={val.id} value={val.id} >{val.role}</option>
                                })
                            }
                        </select>
                        {errors.job_role_id && <span className="is-danger">*Required</span>}
                    </div>

                    {
                        companyTypeDealer && (

                            <>
                            
                                <div className="col-sm-6 mb-3">
                                    <label>Distributer Name</label>

                                    <input type="text" className="form-control form-control-lg" name="distributor" placeholder="Distributor Name" {...register("distributor",{ required : true})}
                                            
                                            onChange={(e) =>  {   setdistributor( e.target.value);} }

                                    />
                                     {errors.distributor && <span className="is-danger">If not applicable, please type "N/A."</span>}
                                </div>

                                <div className="col-sm-6 mb-3">
                                    <label>Distributer Location</label>

                                    <input type="text" className="form-control form-control-lg" name="distributor_location"  placeholder="Distributor Location" {...register("distributor_location",{ required : true})}
                                          
                                            onChange={(e) =>  {   setdistributor_location( e.target.value);} }

                                    />
                                     {errors.distributor_location && <span className="is-danger">If not applicable, please type "N/A."</span>}

                                </div>

                                <div className="col-sm-6 mb-3">
                                    <label>Distributor Sales Representative</label>
                                    <input type="text" className="form-control form-control-lg"   name="sales_representative" placeholder="Distributor Sale Representative" {...register("sales_representative",{ required : true})}
                                            onChange={(e) =>  {   setsales_representative( e.target.value);} }

                                    />
                                    {errors.sales_representative && <span className="is-danger">If not applicable, please type "N/A."</span>}
                                </div>
                            </>
                        )
                    }
                </div>
                <div className="form-group text-center">
                    <button type="submit" className="btn login_btn">Save</button></div>
                </div>

                </form>
            </div>
        </div>
                    
    )
}

export default EditAccountForm

